import React from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table';
import { translate } from 'react-i18next';

import 'react-table/react-table.css';
import { COLUMN_STYLE, getColumnStyle } from './util';

const columnDefaults = {
  ...ReactTableDefaults.column,
  headerClassName: 'react-table-header-wordwrap',
};

export class DataTable extends React.Component {
  static DEFAULT_PAGE_SIZE = 10;

  static ACTION_EDIT = 'edit';
  static ACTION_DUPLICATE = 'duplicate';
  static ACTION_DELETE = 'delete';
  static ACTION_CUSTOM = 'custom';

  constructor(props) {
    super(props);

    this.state = {
      pages: 0,
      pageSize: DataTable.DEFAULT_PAGE_SIZE,
      hasAction: this.hasAction(this.props),
      showInlineEditActionAt: undefined,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      pages: Math.ceil(nextProps.filteredCount / this.state.pageSize),
      hasAction: this.hasAction(nextProps),
    });
  }

  hasAction(props) {
    return [
      'onActionEdit', 'onActionDuplicate', 'onActionDelete', 'onActionCustom',
    ].some(key => props.hasOwnProperty(key));
  }

  editInline(row) {
    this.props.onActionEdit({ original: row.original, index: row.index });
    if (this.props.onActionSave) {
      this.setState({ showInlineEditActionAt: row.index });
    }
  }

  async saveInline(row) {
    const {component_id} = row.original;
    if(component_id){
      this.props.onActionSave(row)
        .then(() => this.setState({ showInlineEditActionAt: undefined }));
    }else {
      await this.props.onActionSave(row);
      this.setState({ showInlineEditActionAt: undefined });
    }
}

  renderAction(row) {
    const {
      onActionCustom,
      customActionIcon,
      onActionEdit,
      onActionDuplicate,
      onActionDelete,
      shouldShowActionMenu,
    } = this.props;

    const menus = [
      {
        iconClassName: customActionIcon,
        actionHandler: onActionCustom,
        actionName: DataTable.ACTION_CUSTOM,
      },
      {
        iconClassName: 'fas fa-edit',
        actionHandler: onActionEdit,
        actionName: DataTable.ACTION_EDIT,
      },
      {
        iconClassName: 'fas fa-copy',
        actionHandler: onActionDuplicate,
        actionName: DataTable.ACTION_DUPLICATE,
      },
      {
        iconClassName: 'fas fa-trash-alt',
        actionHandler: onActionDelete,
        actionName: DataTable.ACTION_DELETE,
      },
    ];

    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'columns',
          justifyContent: 'space-around',
          fontSize: 20,
        }}
      >
        {menus
          .filter(menu => !!menu.actionHandler)
          .map(menu => {
            let newMenu = menu;
            if (menu.actionName === DataTable.ACTION_EDIT) {
              newMenu = { ...menu, actionHandler: this.editInline.bind(this) };
            }
            return {
              ...newMenu,
              visibility: shouldShowActionMenu && !shouldShowActionMenu(menu.actionName, row) ? 'hidden-action' : '',
            };
          })
          .map(menu => (
            <a
              href="#"
              className={menu.visibility}
              key={`menu-${menu.actionName}`}
              onClick={() => menu.actionHandler({ original: row.original, index: row.index })}
            >
              <i className={menu.iconClassName} />
            </a>
          ))}
      </div>
    );
  }

  renderInlineEditAction(row) {
    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'columns',
          justifyContent: 'space-around',
          fontSize: 20,
        }}
      >
        <a href="#" onClick={() => this.saveInline(row)}>
          <i className="fas fa-save" />
        </a>
        <a href="#"
           onClick={() => this.setState({ showInlineEditActionAt: undefined },
             () => { this.props.onActionCancel && this.props.onActionCancel() })}
        >
          <i className="fas fa-times text-danger" />
        </a>
      </div>
    );
  }

  render() {
    const columns = [
      ...this.props.columns,
    ];

    if (this.state.hasAction) {
      columns.push({
        Header: '',
        Cell: row => row.index === this.state.showInlineEditActionAt ? this.renderInlineEditAction(row) : this.renderAction(row),
        Footer: this.props.actionFooter,
        ...getColumnStyle(COLUMN_STYLE.action),
      });
    }
    const { t } = this.props;

    let paginationAndSortAttrs = {};
    if (this.props.onFetchData) {
      paginationAndSortAttrs = {
        ...paginationAndSortAttrs,
        onFetchData: state => this.props.onFetchData(state),
        manual: true,
        pages: this.state.pages,
      };
    }

    return (
      <div style={{ display: 'flex', flexFlow: 'column' }}>
        <ReactTable
          style={{ fontFamily: '"Sukhumvit", "Helvetica Neue", Helvetica, Arial, sans-serif' }}
          column={columnDefaults}
          columns={columns}
          data={this.props.data}
          loading={this.props.isLoading}
          {...paginationAndSortAttrs}
          onPageSizeChange={pageSize =>
            this.setState({
              pages: Math.ceil(this.props.filteredCount / pageSize),
              pageSize,
            })
          }
          sortable={this.props.sortable}
          SubComponent={this.props.SubComponent}
          defaultPageSize={DataTable.DEFAULT_PAGE_SIZE}
          className="-striped -highlight"
          previousText={t('previous')}
          nextText={t('next')}
          loadingText={`${t('loading')}...`}
          noDataText={t('no rows found')}
          pageText={t('page')}
          ofText={t('of')}
          rowsText={t('rows')}
        />
      </div>
    );
  }
}

export default translate('translations')(DataTable);



// WEBPACK FOOTER //
// ./src/components/datatable/DataTable.js